import * as tslib_1 from "tslib";
import { EventEmitter, ViewContainerRef } from '@angular/core';
import { InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var SimpleToggleComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SimpleToggleComponent, _super);
    function SimpleToggleComponent(_vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.toggleChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(SimpleToggleComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    SimpleToggleComponent.prototype.onToggleChange = function () {
        this.toggleChange.emit(this.toggleValue);
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], SimpleToggleComponent.prototype, "toggleValue", void 0);
    return SimpleToggleComponent;
}(BaseComponent));
export { SimpleToggleComponent };
